export default __webpack_public_path__ + "static/media/pakrap-13.0e92f997.mp3";